import Vue from 'vue'
import axios from 'axios';
import App from './App.vue'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import router from './router'
import store from './store'
import Cookies from 'js-cookie'
import { FormModel, Carousel, Modal } from 'ant-design-vue';
import VueHtmlToPaper from 'vue-html-to-paper';
import 'bootstrap';
import './assets/css/style.css'
import '../public/css/invoice.css'
import 'bootstrap/dist/css/bootstrap.min.css';
import vueCountryRegionSelect from 'vue-country-region-select'
import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
import Print from 'vue-print-nb'
import { notification } from 'ant-design-vue';



Vue.config.productionTip = false


Vue.prototype.$notification = notification;

const options = {
	name: '_blank',
	specs: ['fullscreen=yes', 'titlebar=yes', 'scrollbars=yes'],
	styles: [
		'https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css',
		'https://unpkg.com/kidlat-css/css/kidlat.css',
	],
};

Vue.use(vueCountryRegionSelect)
Vue.use(VueHtmlToPaper, options);
Vue.use(Print);
Vue.use(Antd);
Vue.use(FormModel);
Vue.use(Carousel);
Vue.use(Modal);

axios.interceptors.response.use( (response) => {
  // Return a successful response back to the calling service
  return response;
}, (error) => {

  console.log('Error | ', error.message);
  // Return any error which is not due to authentication back to the calling service
  
  if (error.response.status !== 401) {
    return new Promise((resolve, reject) => {
      reject(error);
    });
  }

  // Logout user with authentication error
  if (error.response.status === 401 && error.response.data.code === "authentication_error") {
      store.dispatch('logout')
  }

  // Try request again with new token
  // return store.dispatch('getNewToken').then((token) => {
  //   // New request with new token
  //   const config = error.config;
  //   config.headers['Authorization'] = `${token}`;
    
  //   return new Promise((resolve, reject) => {
  //     axios.request(config).then(response => {
  //       resolve(response);
  //     }).catch((error) => {
  //       reject(error);
  //     })
  //   });
  // }).catch((error) => {
  //   Promise.reject(error);
  // });
});

Vue.use(Cookies)

new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
